class AddonSocketService {
    constructor() {
        if (new.target === AddonSocketService) {
            throw new Error("Cannot instantiate abstract class");
        }

        if (this.connect === AddonSocketService.prototype.connect) {
            throw new Error("Must implement connect method");
        }

        if (this.disconnect === AddonSocketService.prototype.disconnect) {
            throw new Error("Must implement disconnect method");
        }

        if (this.getSocketId === AddonSocketService.prototype.getSocketId) {
            throw new Error("Must implement getSocketId method");
        }
    }

    connect() {
        throw new Error("Method 'connect()' must be implemented");
    }

    disconnect() {
        throw new Error("Method 'disconnect()' must be implemented");
    }

    getSocketId() {
        throw new Error("Method 'getSocketId()' must be implemented");
    }
}

export default AddonSocketService; 